import React from "react";

function InputFileHook({ name, accept, register, setFileName }) {
  const handleFile = (files) => {
    let fileName = 'Seleccione un archivo';
    if (files.length !== 0) {
      fileName = files[0].name;
    }
    setFileName(fileName);
  }
  return (
    <input
      type="file"
      name={name}
      accept={accept}
      ref={register({ required: true })}
      onChange={(e) => handleFile(e.target.files)}
    />
  );
}

export default InputFileHook;
